import { colors } from '@atlaskit/theme';
import { Dimensions } from 'components/visuals';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { styled } from 'styled-components';
import { messages } from '../messages';
import { useDispatch, useSelector } from 'react-redux';
import { getMACUserChannel, selectSwitchedUser } from '../duck/selectors';
import SectionMessage from '@atlaskit/section-message';
import { restoreSwitchUserEmail } from '../duck/actions/configUser';
import { fetchGetCustomerByEmail } from '../duck/actions/contact';
import { getCurrentContactEmail } from 'modules/auth/selectors';
import { route } from '../duck/actions/landing';
import { Action, redirect } from 'redux-first-router';
import { StyledActionsButtonLink } from './licensesExpandedRow/StyledComponents';
import { checkFeatureGate, FeatureFlags } from '../../../util/statsig';
import config from 'appconfig';
import { CloudSiteMigrationsLink } from '../../../util/constants';
import { State } from '../../../model/State';

const StyledMainMACHeader = styled.h1`
  margin: ${Dimensions.unit}px 0 ${Dimensions.unit * 3}px;
  color: ${colors.N800};
`;

const MigrationCloudsBanner = styled.div`
  padding: ${Dimensions.unit * 2}px 0;
`;

const MACPageHeader = () => {
  const dispatch = useDispatch();

  const currentUserEmail = useSelector(getCurrentContactEmail) || '';
  const switchedUserEmail = useSelector(selectSwitchedUser) || '';
  const { isPartner } = useSelector((state: State) => getMACUserChannel(state));

  const [isSwitchedUser, setIsSwitchedUser] = useState(false);
  const migrationCloudsFunctionality = checkFeatureGate(
    FeatureFlags.MIGRATION_CLOUDS_BANNER_FOR_PARTNERS,
  );

  useEffect(() => {
    if (
      currentUserEmail !== '' &&
      switchedUserEmail !== '' &&
      currentUserEmail !== switchedUserEmail
    ) {
      setIsSwitchedUser(true);
    } else {
      setIsSwitchedUser(false);
    }
  }, [currentUserEmail, switchedUserEmail]);

  const handleEmailRestore = () => {
    if (currentUserEmail) {
      dispatch(fetchGetCustomerByEmail(currentUserEmail));
    }
    dispatch(restoreSwitchUserEmail());
    dispatch(redirect(route() as Action));
  };
  return (
    <>
      {isPartner && migrationCloudsFunctionality && (
        <MigrationCloudsBanner>
          <SectionMessage appearance="warning">
            <FormattedMessage
              {...messages.migrationCloudsBanner}
              values={{
                cloudSiteMigrations: (
                  <a rel="noopener noreferrer" target="_blank" href={CloudSiteMigrationsLink}>
                    <FormattedMessage {...messages.migrationCloudsSite} />
                  </a>
                ),
                ppcLink: (
                  <a rel="noopener noreferrer" target="_blank" href={config.ppcUrl}>
                    <FormattedMessage {...messages.migrationCloudsBannerPPC} />
                  </a>
                ),
                date: (
                  <strong>
                    <FormattedMessage {...messages.migrationCloudsDate} />
                  </strong>
                ),
              }}
            />
          </SectionMessage>
        </MigrationCloudsBanner>
      )}
      <StyledMainMACHeader>
        <FormattedMessage {...messages.macMainHeader} />
      </StyledMainMACHeader>
      {isSwitchedUser && (
        <>
          <SectionMessage
            appearance="information"
            actions={[
              <StyledActionsButtonLink
                key="mac-revert-switched-user-button"
                appearance="link"
                onClick={handleEmailRestore}
                data-cy="mac-revert-switched-user-button"
                spacing="compact"
              >
                <FormattedMessage {...messages.switchUserButtonRevert} />
              </StyledActionsButtonLink>,
            ]}
            testId="mac-switched-user-main-banner"
          >
            <FormattedMessage
              {...messages.macMainSwitchedUserBanner}
              values={{
                switchedUserEmail,
              }}
            />
          </SectionMessage>
          <br />
        </>
      )}
    </>
  );
};

export default MACPageHeader;
